// File: noviopus-ats-client/src/features/Organization/organizationSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OrganizationState, OrganizationInterface, WorkplaceDictionaries } from './types';

export const initialState: OrganizationState = {
  data: null, 
  loading: false,
  error: null,
  saveStatus: 'idle',
  dictionaries: {
    industries: [],
    employees: [],
    workplace: {
      workplaceTypes: [],
      benefits: [],
      foodServices: [],
      parking: []
    }
  }
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {

    createOrganization: (state, action: PayloadAction<OrganizationInterface>) => {
      state.loading = true;
      state.saveStatus = 'saving';
      state.error = null;
    },
    updateOrganization: (state, action: PayloadAction<{ id: string; data: OrganizationInterface }>) => {
      state.loading = true;
      state.saveStatus = 'saving';
      state.error = null;
    },
    fetchOrganization: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    deleteOrganization: (state, action: PayloadAction<string>) => {
        state.loading = true;
        state.error = null;
    },

    saveOrganizationSuccess: (state, action: PayloadAction<OrganizationInterface>) => {
      state.data = action.payload;
      state.loading = false;
      state.saveStatus = 'success';
      // Note: We intentionally do NOT auto-select here to avoid jumping context unexpectedly
      // state.selectedOrganization = action.payload; 
    },
    saveOrganizationFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.saveStatus = 'error';
      state.error = action.payload;
    },
    fetchOrganizationSuccess: (state, action: PayloadAction<OrganizationInterface>) => {
      state.data = action.payload;
      state.loading = false;
    },
    fetchOrganizationFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    
    fetchIndustries: (state) => {},
    fetchIndustriesSuccess: (state, action: PayloadAction<any[]>) => {
      if (!state.dictionaries) state.dictionaries = { ...initialState.dictionaries };
      state.dictionaries.industries = action.payload;
    },

    fetchEmployees: (state) => {},
    fetchEmployeesSuccess: (state, action: PayloadAction<any[]>) => {
      if (!state.dictionaries) state.dictionaries = { ...initialState.dictionaries };
      state.dictionaries.employees = action.payload;
    },

    fetchWorkplaceDictionaries: (state) => {},
    fetchWorkplaceDictionariesSuccess: (state, action: PayloadAction<WorkplaceDictionaries>) => {
      if (!state.dictionaries) state.dictionaries = { ...initialState.dictionaries };
      state.dictionaries.workplace = action.payload;
    },

    deleteOrganizationSuccess: (state) => {
        state.data = null;
        state.loading = false;
    },
    
    resetOrganizationState: () => {
        console.log('[TRACER] organization/resetOrganizationState called');
        return initialState;
    },
    
    resetSaveStatus: (state) => {
        state.saveStatus = 'idle';
        state.error = null;
        state.loading = false;
    }
  },
});

export const {
  createOrganization,
  updateOrganization,
  fetchOrganization,
  deleteOrganization, 
  saveOrganizationSuccess,
  saveOrganizationFailure,
  fetchOrganizationSuccess,
  fetchOrganizationFailure,
  deleteOrganizationSuccess, 
  fetchIndustries,
  fetchIndustriesSuccess,
  fetchEmployees,
  fetchEmployeesSuccess,
  fetchWorkplaceDictionaries,
  fetchWorkplaceDictionariesSuccess,
  resetOrganizationState,
  resetSaveStatus
} = organizationSlice.actions;

export default organizationSlice.reducer;